import moment from 'moment'
import React, {useEffect, useMemo, useState} from 'react'
import {Spinner, OverlayTrigger, Tooltip} from 'react-bootstrap'
import {Check} from 'react-bootstrap-icons'
import {KTSVG} from '../../../../_metronic/helpers'
import NodataYet from '../../../Components/NodataYet'

import {GetAllAccountId, getAccountIdList} from '../AllCellCastUser/UserListSlice/UserListSlice'
import {useDispatch, useSelector} from 'react-redux'
import {useNavigate, Link} from 'react-router-dom'
import {getWhiteLableList} from '../WhiteLabel/WhiteLabelSlice/WhiteLabelSlice'
import Select from 'react-select'
import {
  GetAllMessageData,
  getAllMessageReport,
  storeReportId,
  storeSchedulerId,
} from '../../UserPages/reports-analytics/reportSlices/reportAnalytics'
import axios from 'axios'
import ReactPaginate from 'react-paginate'
import {GeneralDataOFLoginUser} from '../../../Utils/Auth'
import {ENV} from '../../../Utils/_helpers/EnvHelper'
import {toast} from 'react-toastify'
import {
  useAdminUpdateSmsStatusMutation,
  useCancelCampaignMutation,
  useGetAllInprogressCampaignCountQuery,
  useLazyGetAllCampaignReportExportQuery,
  useRescheduleCampaignMutation,
} from '../../../../services/cellcast'
import {
  usePauseCampaignMutation,
  useResumeCampaignMutation,
  useCancelCampaignMutation as useCancelSendingCampaignMutation,
} from '../../../../services/cellcast.v2'
import DeleteConfirmationPopup from '../../../Components/DeleteConfirmationPopup'

import {Container, Row, Col, Card} from 'react-bootstrap'
import {HourglassSplit, ArrowRepeat} from 'react-bootstrap-icons' // Optional: use Bootstrap icons

type CampaignStats = {
  scheduled: number
  inProgress: number
}

type CampaignOverviewProps = {
  smsStats: CampaignStats
  mmsStats: CampaignStats
}

const CampaignOverview: React.FC<CampaignOverviewProps> = ({smsStats, mmsStats}) => {
  return (
    <div className='py-4'>
      <Row className='g-3'>
        {[
          {label: 'SMS Campaigns', data: smsStats},
          {label: 'MMS Campaigns', data: mmsStats},
        ].map(({label, data}, index) => (
          <Col key={index} md={6}>
            <Card className='shadow-sm rounded-4 p-3 h-100 px-8'>
              <h3 className='card-label fw-bolder fs-2 mb-1 text-dark fw-400 d-block fs-6 mb-3'>
                {label}
              </h3>
              <Row className='align-items-center mb-2'>
                <Col xs={1}>
                  <HourglassSplit className='text-warning' size={18} />
                </Col>
                <Col>Scheduled</Col>
                <Col className='text-end fw-bold'>{data.scheduled}</Col>
              </Row>
              <Row className='align-items-center'>
                <Col xs={1}>
                  <ArrowRepeat className='text-primary' size={18} />
                </Col>
                <Col>In Progress</Col>
                <Col className='text-end fw-bold'>{data.inProgress}</Col>
              </Row>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  )
}

const CampaignLog = () => {
  const isUserWhiteLabel = GeneralDataOFLoginUser()?.isWhiteLabelUser === true
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const accountIdList = useSelector(getAccountIdList)
  const messageData = useSelector(GetAllMessageData)
  const [messageCampType, setMessageCampType] = useState('sms')
  const [bulkPage, setBulkPage] = useState(1)
  const [accountId, setAccountId] = useState('')
  const API_URL = ENV().REACT_APP_API_URL
  /////////USE SELECTOR//////////////////////////////////////
  const whiteLabelAccountList = useSelector(getWhiteLableList)
  const today = new Date() // Current date
  const sevenDaysAgo = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000)
  const [dateRange, setDateRange] = useState<any>([sevenDaysAgo, new Date()])

  const [startDate, endDate] = dateRange

  const [updateSmsStatus, {isLoading: isUpdateSmsStatus}] = useAdminUpdateSmsStatusMutation()
  const [selectedBulk, setSelectedBulk] = useState<{interval?: number; scheduleAt?: number} | null>(
    null
  )

  const [rescheduleParam, setRescheduleParam] = useState<{
    id: string
    staggerMessages: boolean
    staggerId: null | string
    type: string
    scheduleAt?: number
    interval?: number
  } | null>(null)

  const {data: inprogressCampaignCount} = useGetAllInprogressCampaignCountQuery(null)

  useEffect(() => {
    if (!isUserWhiteLabel) {
      dispatch(GetAllAccountId())
    }
  }, [])

  useEffect(() => {
    if (accountIdList?.length > 0) {
      setAccountId(accountIdList?.find((x: any) => x.companyName === 'cellcast')?._id)
    }
  }, [accountIdList])

  useEffect(() => {
    if (!!accountId) {
      dispatch(
        getAllMessageReport({
          fromDate: moment(startDate).format('YYYY-MM-DD'),
          toDate: moment(endDate).format('YYYY-MM-DD'),
          camp_type: messageCampType,
          page: bulkPage,
          accountId,
          adminLogReport: true,
        })
      )
    }
  }, [bulkPage, messageCampType, accountId])

  const getSmsStatusText = (smsStatus: string) => {
    if (smsStatus === 'approved') {
      return <label className='fw-bold fs-7 text-success mt-3 text-nowrap'>Verified Account</label>
    }
    return <label className='fw-bold fs-7 text-danger mt-3 text-nowrap'>Unverified Account</label>
  }

  const handleUpdateSmsStatus = (userId: string, userStatus: string) => {
    let statusUpdate = 'approved' // original status
    if (userStatus === 'approved') {
      statusUpdate = 'newUser'
    }

    updateSmsStatus({
      userId: userId,
      status: statusUpdate,
    })
      .then((res) => {
        if ('data' in res) {
          toast.success(res.data?.message)
        } else if ('error' in res) {
          toast.error(res.error)
          console.error('Error verify user:', res.error)
        }
      })
      .catch((err) => {
        toast.error(err.error)
      })
      .finally(
        dispatch(
          getAllMessageReport({
            fromDate: moment(startDate).format('YYYY-MM-DD'),
            toDate: moment(endDate).format('YYYY-MM-DD'),
            camp_type: messageCampType,
            page: bulkPage,
            accountId,
            adminLogReport: true,
          })
        )
      )
  }

  const [isOpenConfirmation, setIsOpenConfirmation] = useState(false)
  const [cancelParam, setCancelParam] = useState<{
    id: string
    staggerMessages: boolean
    staggerId: null | string
    type: string
  } | null>(null)

  // cancel
  const [isOpenCancelConfirmation, setIsOpenCancelConfirmation] = useState(false)
  const [cancelIdParam, setCancelIdParam] = useState('')
  const [cancelSendingMessage, {isLoading: cancelCampaignLoading}] =
    useCancelSendingCampaignMutation()

  // pause
  const [isOpenPauseConfirmation, setIsOpenPauseConfirmation] = useState(false)
  const [pauseIdParam, setPauseIdParam] = useState('')
  const [pauseSendingMessage, {isLoading: pauseCampaignLoading}] = usePauseCampaignMutation()

  // resume
  const [isOpenResumeConfirmation, setIsOpenResumeConfirmation] = useState(false)
  const [resumeIdParam, setResumeIdParam] = useState('')
  const [resumeSendingMessage, {isLoading: resumeCampaignLoading}] = useResumeCampaignMutation()

  // reschedule
  const [isOpenRescheduleConfirmation, setIsOpenRescheduleConfirmation] = useState(false)
  const [rescheduleCampaign, {isLoading: rescheduleLoading}] = useRescheduleCampaignMutation()

  // campaignType
  const [campaignType, setCampaignType] = useState('')

  const getDisplayStatus = (key: any) => {
    if (key?.cancelledAt || key?.canceledAt) {
      return 'Canceled'
    }
    if (key?.pausedAt) {
      return 'Paused'
    }
    if (key?.finalStatus !== 'In Progress') {
      return key?.finalStatus
    }

    return 'In Progress'
  }

  const getStatusColor = (key: any): string => {
    const status = getDisplayStatus(key)
    switch (status) {
      case 'In Progress':
      case 'Paused':
      case 'Scheduled':
        return 'warning'
      case 'Canceled':
      case 'Failed':
        return 'danger'
      default:
        return 'success'
    }
  }

  const cancelConfirmation = useMemo(
    () => (
      <DeleteConfirmationPopup
        show={isOpenConfirmation}
        handleClose={() => {
          setIsOpenConfirmation(false)
          setCancelParam(null)
        }}
        Message={'Are you sure, you want to cancel the campaign ?'}
        confirm={() => {
          if (cancelParam) {
            handleCancelCampaign(cancelParam.id, cancelParam.staggerMessages, cancelParam.staggerId)
            setCancelParam(null)
          }
        }}
        confirmBtnTitle='Yes, cancel campaign'
      />
    ),
    [isOpenConfirmation, cancelParam]
  )

  const rescheduleConfirmation = useMemo(
    () => (
      <DeleteConfirmationPopup
        show={isOpenRescheduleConfirmation}
        handleClose={() => {
          setIsOpenRescheduleConfirmation(false)
          setRescheduleParam(null)
        }}
        Message={'Are you sure, you want to reschedule the campaign ?'}
        selectedBulk={selectedBulk}
        isReschedule={true}
        confirm={({interval, scheduleAt}: {interval: number; scheduleAt: number}) => {
          if (rescheduleParam) {
            handleRescheduleCampaign(
              rescheduleParam.id,
              rescheduleParam.staggerMessages,
              rescheduleParam.staggerId,
              scheduleAt ? moment(scheduleAt).unix() : 0,
              interval
            )
            setRescheduleParam(null)
          }
        }}
        confirmBtnTitle='Yes, reschedule campaign'
      />
    ),
    [isOpenRescheduleConfirmation, rescheduleParam]
  )

  const cancelSendingMessageConfirmation = useMemo(
    () => (
      <DeleteConfirmationPopup
        show={isOpenCancelConfirmation}
        handleClose={() => {
          setIsOpenCancelConfirmation(false)
          setCancelIdParam('')
        }}
        Message={'Are you sure, you want to cancel this campaign ?'}
        confirm={() => {
          if (cancelIdParam) {
            cancelSendingMessage({
              bulkId: cancelIdParam,
              type: campaignType,
            })
              .then((res) => {
                if ('data' in res) {
                  toast.success(res.data?.message)
                } else if ('error' in res) {
                  toast.error(res.error)
                  console.error('Error cancel campaign :', res.error)
                }
              })
              .catch((err) => {
                toast.error(err.error)
              })
              .finally(() => {
                setIsOpenCancelConfirmation(false)
                setCancelIdParam('')
                setCampaignType('')

                dispatch(
                  getAllMessageReport({
                    fromDate: moment(startDate).format('YYYY-MM-DD'),
                    toDate: moment(endDate).format('YYYY-MM-DD'),
                    camp_type: messageCampType,
                    page: bulkPage,
                    accountId,
                    adminLogReport: true,
                  })
                )
              })
          }
        }}
        confirmBtnTitle='Yes, cancel campaign'
      />
    ),
    [isOpenCancelConfirmation, cancelIdParam, cancelSendingMessage]
  )

  const pauseSendingMessageConfirmation = useMemo(
    () => (
      <DeleteConfirmationPopup
        show={isOpenPauseConfirmation}
        handleClose={() => {
          setIsOpenPauseConfirmation(false)
          setPauseIdParam('')
        }}
        Message={'Are you sure, you want to pause this campaign ?'}
        confirm={() => {
          if (pauseIdParam) {
            pauseSendingMessage({
              bulkId: pauseIdParam,
              type: campaignType,
            })
              .then((res) => {
                if ('data' in res) {
                  toast.success(res.data?.message)
                } else if ('error' in res) {
                  toast.error(res.error)
                  console.error('Error pause campaign :', res.error)
                }
              })
              .catch((err) => {
                toast.error(err.error)
              })
              .finally(() => {
                setIsOpenPauseConfirmation(false)
                setPauseIdParam('')
                setCampaignType('')

                dispatch(
                  getAllMessageReport({
                    fromDate: moment(startDate).format('YYYY-MM-DD'),
                    toDate: moment(endDate).format('YYYY-MM-DD'),
                    camp_type: messageCampType,
                    page: bulkPage,
                    accountId,
                    adminLogReport: true,
                  })
                )
              })
          }
        }}
        confirmBtnTitle='Yes, pause campaign'
      />
    ),
    [isOpenPauseConfirmation, pauseIdParam, pauseSendingMessage]
  )

  const resumeSendingMessageConfirmation = useMemo(
    () => (
      <DeleteConfirmationPopup
        show={isOpenResumeConfirmation}
        handleClose={() => {
          setIsOpenResumeConfirmation(false)
          setResumeIdParam('')
          setSelectedBulk(null)
        }}
        Message={'Do you want to resume this campaign, please select an option below'}
        selectedBulk={selectedBulk}
        withIntervalConfirmation={true}
        confirm={({interval, scheduleAt}: {interval: number; scheduleAt: string}) => {
          if (resumeIdParam) {
            resumeSendingMessage({
              bulkId: resumeIdParam,
              type: campaignType,
              interval,
              scheduleAt: scheduleAt ? moment(scheduleAt).unix() : 0,
            })
              .then((res) => {
                if ('data' in res) {
                  toast.success(res.data?.message)
                } else if ('error' in res) {
                  toast.error(res.error)
                  console.error('Error resume campaign :', res.error)
                }
              })
              .catch((err) => {
                toast.error(err.error)
              })
              .finally(() => {
                setIsOpenResumeConfirmation(false)
                setResumeIdParam('')
                setCampaignType('')
                setSelectedBulk(null)
              })
          }
        }}
        confirmBtnTitle='Yes, resume campaign'
      />
    ),
    [isOpenResumeConfirmation, resumeIdParam, resumeSendingMessage, selectedBulk]
  )

  const [cancelCampaign, {isLoading: cancelLoading}] = useCancelCampaignMutation()
  const [getApiExport, {isLoading: isLoadingDownload}] = useLazyGetAllCampaignReportExportQuery()

  const handleCancelCampaign = (
    id: string,
    staggerMessages: boolean = false,
    staggerId: null | string = null
  ) => {
    cancelCampaign({id, staggerId, staggerMessages})
      .then((res: any) => {
        if ('data' in res) {
          toast.success(res.data?.message)
        } else if ('error' in res) {
          toast.error(res.error)
          console.error('Error cancel campaign:', res.error)
        }
      })
      .finally(() => {
        dispatch(
          getAllMessageReport({
            fromDate: moment(startDate).format('YYYY-MM-DD'),
            toDate: moment(endDate).format('YYYY-MM-DD'),
            camp_type: messageCampType,
            page: bulkPage,
            accountId,
            adminLogReport: true,
          })
        )
      })
  }

  const handleRescheduleCampaign = (
    id: string,
    staggerMessages: boolean = false,
    staggerId: null | string = null,
    scheduleAt?: number,
    interval?: number
  ) => {
    rescheduleCampaign({id, staggerId, staggerMessages, scheduleAt, interval})
      .then((res) => {
        if ('data' in res) {
          toast.success(res.data?.message)
        } else if ('error' in res) {
          toast.error(res.error)
          console.error('Error cancel campaign:', res.error)
        }
      })
      .finally(() => {
        dispatch(
          getAllMessageReport({
            fromDate: moment(startDate).format('YYYY-MM-DD'),
            toDate: moment(endDate).format('YYYY-MM-DD'),
            camp_type: messageCampType,
            page: bulkPage,
            accountId,
            adminLogReport: true,
          })
        )
      })
  }

  return (
    <>
      <CampaignOverview
        smsStats={{
          scheduled: inprogressCampaignCount?.data?.sms?.scheduled,
          inProgress: inprogressCampaignCount?.data?.sms?.inProgress,
        }}
        mmsStats={{
          scheduled: inprogressCampaignCount?.data?.mms?.scheduled,
          inProgress: inprogressCampaignCount?.data?.mms?.inProgress,
        }}
      />
      <div className={`sub-accountstable card `}>
        {cancelConfirmation}
        {rescheduleConfirmation}
        {cancelSendingMessageConfirmation}
        {pauseSendingMessageConfirmation}
        {resumeSendingMessageConfirmation}
        <div className='row'>
          <div className='card p-8'>
            <div className='card-header border-0 p-0 align-items-center'>
              <h3 className='card-title align-items-start  flex-column'>
                <span className='card-label fw-bolder fs-2 mb-1'>All Bulk Messages</span>
                <span className='text-muted mt-1 fw-bold fs-7'>Ordered by most recent</span>
              </h3>
              <div className='d-flex gap-4'>
                <div className='card-toolbar align-items-start'>
                  <Select
                    options={accountIdList?.map((key: any) => ({
                      value: key?._id,
                      label: key?.companyName,
                    }))}
                    onChange={(e: any) => setAccountId(e.value)}
                    value={
                      accountId !== ''
                        ? {
                            value: accountId,
                            label: accountIdList?.find((key: any) => key?._id === accountId)
                              ?.companyName,
                          }
                        : {value: '', label: 'Select Account ID'}
                    }
                  />
                </div>
                <div className='card-toolbar align-items-start'>
                  <Select
                    value={{value: messageCampType, label: messageCampType?.toUpperCase()}}
                    options={[
                      {value: 'sms', label: 'SMS'},
                      {value: 'mms', label: 'MMS'},
                    ]}
                    onChange={(e: any) => setMessageCampType(e?.value)}
                  />
                </div>
              </div>
            </div>
            {messageData?.items?.length > 0 ? (
              <div className='card-body p-0 pt-5'>
                <div className='table-responsive'>
                  <table className='table align-middle gs-0 gy-5 all-message-table'>
                    <thead>
                      <tr className='fw-400 text-muted '>
                        <th className='p-0 w-40px ps-0'>TYPE</th>
                        <th className='p-0 w-210px'>ACCOUNT</th>
                        <th className='p-0 w-210px'>CAMPAIGN</th>
                        <th className='p-0 min-w-150px ps-3'>SENT DATE</th>
                        <th className='p-0 min-w-40px ps-2'>RECIPIENTS</th>
                        <th className='p-0 min-w-40px ps-2'>STAGGER</th>
                        <th className='p-0 min-w-40px ps-2'>UNSUB</th>
                        <th className='p-0 min-w-40px ps-3'>CLICK THROUGH</th>
                        <th className='p-0 min-w-40px ps-2'>REPLIES</th>
                        <th className='p-0 min-w-40px ps-3'>STATUS</th>
                        <th className='p-0 min-w-150px ps-3'>ACTION</th>
                      </tr>
                    </thead>
                    <tbody>
                      {messageData?.items?.map((key: any, i: number) => (
                        <tr key={i} className='border-dashed border-2 border-bottom'>
                          <th className='ps-0'>
                            <div className='symbol symbol-50px me-2'>
                              <span className='symbol-label'>
                                <a className='badge green_text_badge fs-7 badge-square p-4 w-50px h-50px'>
                                  {key?.camp_type}
                                </a>
                              </span>
                            </div>
                          </th>
                          <th>
                            <span className='text-dark fw-400 d-block mb-1 fs-6'>
                              {key?.userDetails?.name}
                            </span>
                            <span className='text-gray-400 fw-light d-block p-0'>
                              {key?.userDetails?.email}
                            </span>
                            <span className='text-gray-400 fw-light d-block p-0'>
                              {key?.userDetails?.mobile}
                            </span>

                            <div className='form-check form-check-sm form-check-custom form-check-solid d-flex flex-column'>
                              <div className='d-flex'>
                                <input
                                  className='form-check-input me-3 mt-3'
                                  type='checkbox'
                                  checked={key?.userDetails?.smsStatus === 'approved'}
                                  onChange={() =>
                                    handleUpdateSmsStatus(key?.user, key?.userDetails?.smsStatus)
                                  }
                                />
                                {getSmsStatusText(key?.userDetails?.smsStatus)}
                              </div>
                            </div>
                          </th>

                          <td className=''>
                            <span className='text-dark fw-400 p-0 d-block mb-1 fs-6'>
                              {key?.name}
                            </span>
                            <span className='text-gray-400 fw-light p-0'>
                              Created {moment(key?.createdAt).format('l')}
                            </span>
                          </td>
                          <td>
                            <span className='text-dark fw-400  d-block mb-1 fs-6'>
                              <span className='text-dark fw-400  d-block mb-1 fs-6'>
                                {key?.scheduleAt
                                  ? moment(key?.scheduleAt).format('MMMM DD, YYYY hh:mm A')
                                  : moment(key?.createdAt).format('MMMM DD, YYYY hh:mm A')}
                              </span>
                            </span>
                          </td>
                          <td>
                            <span className='text-dark fw-400  d-block mb-1 fs-6'>
                              {key?.staggerId && key?.totalRecipients
                                ? `${key?.completedRecipients}/${key?.totalRecipients}`
                                : key?.recipients}
                            </span>
                          </td>
                          <td>
                            <span className='text-dark fw-400  d-block mb-1 fs-6'>
                              {key?.staggerId && key?.totalRecipients
                                ? `${key?.completedCount} / ${
                                    key?.completedCount + key?.scheduledCount
                                  }`
                                : '-'}
                            </span>
                          </td>
                          <td>
                            <span className='text-dark fw-400  d-block mb-1 fs-6'>
                              {key?.unsub}
                            </span>
                          </td>
                          <td>
                            <span className='text-dark fw-400  d-block mb-1 fs-6'>
                              {key?.clickThrough}
                            </span>
                          </td>
                          <td>
                            <span className='text-dark fw-400  d-block mb-1 fs-6'>
                              {key?.replies}
                            </span>
                          </td>

                          <td>
                            <span className={`badge badge-light-${getStatusColor(key)} fw-bold`}>
                              {getDisplayStatus(key)}
                            </span>
                            <div className=''>
                              {(key?.canceledAt || key?.pausedAt) &&
                                moment(key?.canceledAt || key?.pausedAt).format(
                                  'MMMM DD, YYYY hh:mm A'
                                )}
                            </div>
                          </td>
                          <td className='text-end'>
                            <>
                              {/* Show Detail Button */}
                              {
                                <OverlayTrigger
                                  placement='top'
                                  overlay={<Tooltip id='button-tooltip'>View Detail</Tooltip>}
                                >
                                  <Link
                                    to={`${
                                      key?.finalStatus?.toLowerCase() !== 'scheduled'
                                        ? '/eofy/snapshot'
                                        : '/scheduler/snapshot'
                                    }`}
                                    target='_blank'
                                    onClick={() => {
                                      // Completed campaign
                                      if (key?.finalStatus?.toLowerCase() === 'completed') {
                                        dispatch(
                                          storeReportId({
                                            id: key?._id,
                                            camp_type: messageCampType,
                                          })
                                        )

                                        return
                                      }

                                      if (key?.finalStatus?.toLowerCase() === 'scheduled') {
                                        dispatch(
                                          storeSchedulerId({
                                            id: key?._id,
                                            camp_type: messageCampType,
                                          })
                                        )
                                        return
                                      }

                                      // In progress stagger campaign
                                      if (
                                        key?.staggerId &&
                                        key?.finalStatus?.toLowerCase() === 'in progress' &&
                                        key?.bulkId
                                      ) {
                                        dispatch(
                                          storeReportId({
                                            id: key?.bulkId,
                                            camp_type: messageCampType,
                                          })
                                        )
                                        return
                                      }

                                      // Default state for running campaign
                                      dispatch(
                                        storeReportId({
                                          id: key?.bulkId ? key?.bulkId : key?._id,
                                          camp_type: messageCampType,
                                        })
                                      )
                                    }}
                                    className='btn btn-disable btn-sm btn-icon btn-bg-light btn-active-color-primary'
                                  >
                                    <KTSVG
                                      path='/media/icons/duotune/arrows/arr064.svg'
                                      className='svg-icon-2'
                                    />
                                  </Link>
                                </OverlayTrigger>
                              }

                              {key?.finalStatus?.toLowerCase() !== 'completed' &&
                                !key?.canceledAt &&
                                !key?.pausedAt &&
                                key?._id && (
                                  <>
                                    {/* Show pause and cancel normal campaign  when not scheduled */}
                                    {key?.finalStatus?.toLowerCase() !== 'scheduled' && (
                                      <>
                                        <OverlayTrigger
                                          placement='top'
                                          overlay={<Tooltip id='button-tooltip'>Pause</Tooltip>}
                                        >
                                          <button
                                            className='btn btn-disable btn-sm btn-icon btn-bg-light btn-warning ms-3'
                                            onClick={() => {
                                              setPauseIdParam(key?.bulkId ? key?.bulkId : key?._id)
                                              setCampaignType(messageCampType)
                                              setIsOpenPauseConfirmation(true)
                                            }}
                                          >
                                            {pauseCampaignLoading &&
                                            [key?._id, key?.bulkId].includes(pauseIdParam) ? (
                                              <Spinner />
                                            ) : (
                                              <i className='bi bi-pause fs-5'></i>
                                            )}
                                          </button>
                                        </OverlayTrigger>

                                        <OverlayTrigger
                                          placement='top'
                                          overlay={<Tooltip id='button-tooltip'>Cancel</Tooltip>}
                                        >
                                          <button
                                            className='btn btn-disable btn-sm btn-icon btn-bg-light btn-danger ms-3'
                                            onClick={() => {
                                              setCancelIdParam(key?.bulkId ? key?.bulkId : key?._id)
                                              setCampaignType(messageCampType)
                                              setIsOpenCancelConfirmation(true)
                                            }}
                                          >
                                            {cancelCampaignLoading &&
                                            [key?._id, key?.bulkId].includes(cancelIdParam) ? (
                                              <Spinner />
                                            ) : (
                                              <i className='bi bi-x fs-5'></i>
                                            )}
                                          </button>
                                        </OverlayTrigger>
                                      </>
                                    )}

                                    {/* Show only cancel campaign when it scheduled */}
                                    {key?.finalStatus?.toLowerCase() === 'scheduled' && (
                                      <>
                                        <OverlayTrigger
                                          placement='top'
                                          overlay={
                                            <Tooltip id='button-tooltip'>
                                              Re-Schedule Campaign
                                            </Tooltip>
                                          }
                                        >
                                          <button
                                            className='btn btn-disable btn-sm btn-icon btn-bg-light btn-warning ms-3'
                                            onClick={() => {
                                              setRescheduleParam({
                                                id: key?.queueJobId,
                                                staggerMessages: key?.staggerMessages,
                                                staggerId: key?.staggerId,
                                                type: messageCampType,
                                              })
                                              setSelectedBulk(key)
                                              setIsOpenRescheduleConfirmation(true)
                                            }}
                                            disabled={rescheduleLoading}
                                          >
                                            {rescheduleLoading ? (
                                              <Spinner />
                                            ) : (
                                              <i className='bi bi-pencil fs-5'></i>
                                            )}
                                          </button>
                                        </OverlayTrigger>
                                        <OverlayTrigger
                                          placement='top'
                                          overlay={
                                            <Tooltip id='button-tooltip'>
                                              Cancel Schedule Campaign
                                            </Tooltip>
                                          }
                                        >
                                          <button
                                            className='btn btn-disable btn-sm btn-icon btn-bg-light btn-danger ms-3'
                                            onClick={() => {
                                              setCancelParam({
                                                id: key?.queueJobId,
                                                staggerMessages: key?.staggerMessages,
                                                staggerId: key?.staggerId,
                                                type: messageCampType,
                                              })
                                              setIsOpenConfirmation(true)
                                            }}
                                            disabled={cancelLoading}
                                          >
                                            {cancelLoading ? (
                                              <Spinner />
                                            ) : (
                                              <i className='bi bi-x fs-5'></i>
                                            )}
                                          </button>
                                        </OverlayTrigger>
                                      </>
                                    )}
                                  </>
                                )}

                              {key?.pausedAt && (
                                <>
                                  <OverlayTrigger
                                    placement='top'
                                    overlay={<Tooltip id='button-tooltip'>Resume</Tooltip>}
                                  >
                                    <button
                                      className='btn btn-disable btn-sm btn-icon btn-bg-light btn-info ms-3'
                                      onClick={() => {
                                        setResumeIdParam(key?.bulkId ? key?.bulkId : key?._id)
                                        setSelectedBulk(key)
                                        setCampaignType(messageCampType)
                                        setIsOpenResumeConfirmation(true)
                                      }}
                                    >
                                      {resumeCampaignLoading &&
                                      [key?._id, key?.bulkId].includes(resumeIdParam) ? (
                                        <Spinner />
                                      ) : (
                                        <i className='bi bi-arrow-clockwise fs-5'></i>
                                      )}
                                    </button>
                                  </OverlayTrigger>

                                  <OverlayTrigger
                                    placement='top'
                                    overlay={<Tooltip id='button-tooltip'>Cancel</Tooltip>}
                                  >
                                    <button
                                      className='btn btn-disable btn-sm btn-icon btn-bg-light btn-danger ms-3'
                                      onClick={() => {
                                        setCancelIdParam(key?.bulkId ? key?.bulkId : key?._id)
                                        setCampaignType(messageCampType)
                                        setIsOpenCancelConfirmation(true)
                                      }}
                                    >
                                      {cancelCampaignLoading &&
                                      [key?._id, key?.bulkId].includes(cancelIdParam) ? (
                                        <Spinner />
                                      ) : (
                                        <i className='bi bi-x fs-5'></i>
                                      )}
                                    </button>
                                  </OverlayTrigger>
                                </>
                              )}
                            </>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className='abcd '>
                  <span>Total: {messageData?.total > 10 ? 10 : messageData?.total}</span>
                  <ReactPaginate
                    previousLabel='<'
                    nextLabel='>'
                    pageCount={messageData?.totalPages}
                    onPageChange={(e: any) => setBulkPage(e.selected + 1)}
                    containerClassName={'pagiantion'}
                    previousLinkClassName={'pagination__link'}
                    nextLinkClassName={'pagination__link'}
                    disabledClassName={'pagination__link--disabled'}
                    activeClassName={'pagination__link--active'}
                  />
                </div>
              </div>
            ) : (
              <NodataYet />
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default CampaignLog
